import styled from 'styled-components'

const StatusDropdownContainer = styled.div`
  margin: 0 10px;
`

export default StatusDropdownContainer
